import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, TextField } from '@mui/material'
import SubmitButton from '../../commonUIComponents/SubmitButton'
import { FormProvider } from 'react-hook-form'
import React from 'react'

const CommunityForm = ({ methods, onSubmit, onClose, submitButtonLabel }) => {
  const { handleSubmit, register, formState: { errors } } = methods

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>Tell us about your community</DialogTitle>
        <DialogContent>
          <DialogContentText>
            A name and description help people understand what your community is all about
          </DialogContentText>
          <Grid container spacing={2} sx={{ marginTop: '0.5rem' }}>
            <Grid item xs={12}>
              <TextField
                label="Community Name"
                autoFocus
                required
                margin="dense"
                fullWidth
                variant="standard"
                {...register('id', { required: { value: true, message: 'Invalid Format' }, pattern: /^[A-Za-z0-9]+$/ })}
                error={!!errors?.id}
                helperText={errors.id?.message}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Description"
                required
                margin="dense"
                fullWidth
                variant="standard"
                {...register('description', { required: { value: true, message: 'Invalid Format' } })}
                error={!!errors?.description}
                helperText={errors.description?.message}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Banner Image URL"
                required
                margin="dense"
                fullWidth
                variant="standard"
                {...register('heroImageUrl', { required: { value: true, message: 'Invalid Format' } })}
                error={!!errors?.heroImageUrl}
                helperText={errors.heroImageUrl?.message}
              />
            </Grid>
          </Grid>
          <DialogActions>
            <Button onClick={onClose}>Cancel</Button>
            <SubmitButton buttonLabel={submitButtonLabel} textAlign="right"/>
          </DialogActions>
        </DialogContent>
      </form>
    </FormProvider>
  )
}

export default CommunityForm
